// @ts-strict-ignore
import { HttpParams } from '@angular/common/http';
import { Parameters, WagoApiClient } from '@shared/service/wago-api.client';
import { UserActionInfo } from '../../model/vo/user-action-info';
import { Log } from '@shared/debug/log';
import { ArrayUtils } from '@shared/util/array-utils';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { Injectable } from '@angular/core';
import { SystemConfigurationService } from '@shared/system-configuration/system-configuration-loading.service';
import { StringUtils } from '@shared/util/string-utils';

@Injectable({ providedIn: 'root' })
export class UserActionsLoggingService {
  private static readonly MAX_FUNCTION_LENGTH: number = 255;
  private static readonly MAX_PARAMETER_LENGTH: number = 255;

  constructor(
    private wagoApiClient: WagoApiClient,
    private localeResourceManager: LocaleResourceManager,
    private systemConfigurationService: SystemConfigurationService
  ) {}

  public logActions(userActions: UserActionInfo[], sessionId: string): void {
    if (ArrayUtils.isEmpty(userActions)) {
      return;
    }

    this.wagoApiClient
      .post(`user-actions/log?sessionId=${sessionId}`, userActions, null, {
        isErrorHandlingRequired: false,
        overlayType: null,
      })
      .subscribe({
        next: () => Log.info('User-actions successfully logged'),
        error: (e) => Log.error('Error while logging user-actions: ', e)
      });
  }

  public logArticleAccessorySelection(articleId: number, accessoryArticleId: number): void {
    const params: HttpParams = new HttpParams().set('articleId', articleId.toString()).set('accessoryArticleId', accessoryArticleId.toString());

    this.wagoApiClient.post('configuration/stats/logArticleAccessoryUsage', null, { params: params }).subscribe();
  }

  public logFunction(func: string, parameters: string | boolean = null): void {
    if (!this.systemConfigurationService.currentConfiguration.userActionsLoggingEnabled) {
      return;
    }


    // Was planned to be country, actually using the ui language.
    const country: string = this.localeResourceManager.currentLanguage.langCode;

    const funcParam = StringUtils.truncate(func, UserActionsLoggingService.MAX_FUNCTION_LENGTH);
    const paramParam = (typeof parameters === 'string')
      ? StringUtils.truncate(parameters, UserActionsLoggingService.MAX_PARAMETER_LENGTH)
      : parameters;

    const url: string = 'configuration/stats/logFunctionUsage';
    const httpParams: HttpParams = new HttpParams()
      .set('function', funcParam)
      .set('land', country)
      .set('parameters', paramParam);
    const requestParams: Parameters = { overlayType: null };

    this.wagoApiClient.post(url, null, { params: httpParams }, requestParams).subscribe();
  }
}
